import { ActionType } from '@rc-component/trigger/lib/interface';
import React, { FunctionComponent } from 'react';
import { CSSObject, DefaultTheme } from 'styled-components';

import CustomTooltip from '../Antd/TextTooltip/CustomTooltip';
import { ButtonWrapper, Container, Content, TitleWrapper } from './styled';

type Props = {
  buttonAction?: () => void;
  title: string;
  buttonTitle?: string;
  ZeroStateIcon?: FunctionComponent;
  hideButton?: boolean;
  dataTestId?: string;
  buttonDisabled?: boolean;
  buttonStyles?: (theme: DefaultTheme) => CSSObject;
  className?: string;
  tooltipText?: string;
  tooltipTrigger?: ActionType | ActionType[];
};

const EmptyState = ({
  buttonAction,
  title,
  buttonTitle,
  dataTestId = 'emptyState',
  ZeroStateIcon,
  buttonStyles,
  buttonDisabled = false,
  hideButton = false,
  className,
  tooltipText,
  tooltipTrigger,
}: Props): JSX.Element => (
  <Container data-testid="emptyStateWrapper" className={className}>
    <Content>
      {!!ZeroStateIcon && (
        <div data-testid="zeroSateIcon">
          {' '}
          <ZeroStateIcon />
        </div>
      )}
      <TitleWrapper>{title}</TitleWrapper>
      {!hideButton && (
        <CustomTooltip trigger={tooltipTrigger} title={tooltipText}>
          <div>
            <ButtonWrapper data-testid={dataTestId} type="button" onClick={buttonAction} disabled={buttonDisabled}>
              {buttonTitle}
            </ButtonWrapper>
          </div>
        </CustomTooltip>
      )}
    </Content>
  </Container>
);

export default EmptyState;
